import { render } from "./Splash.vue?vue&type=template&id=3914d67d&scoped=true"
import script from "./Splash.vue?vue&type=script&lang=js"
export * from "./Splash.vue?vue&type=script&lang=js"

import "./Splash.vue?vue&type=style&index=0&id=3914d67d&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3914d67d"]])

export default __exports__